import React, { useEffect, useState } from 'react';
import { Drawer, Timeline, Button, Tooltip, Modal } from 'antd';
import { MdOutlineAddTask } from "react-icons/md";
import { TiEdit, TiEyeOutline } from "react-icons/ti";
import CandidateProfileDrawer from '../components/CandidateProfileDrawer';
import Fetchtable from '../components/Fetchtable';
import AssignInterview from '../components/AssignInterview';
import EditCandidate from './EditCandidate';
import TATTimeline from './TATTimeline';
import styled from 'styled-components';

const URL = process.env.REACT_APP_API_URL;

//const CandidateTable = ({ auth, token, filterOption }) => {
const CandidateTable = ({ auth, candidates }) => {
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [tatDrawerOpen, setTatDrawerOpen] = useState(false); // State for TAT drawer

  const closeModal = () => {
    setIsEditModalVisible(false);
  };

  const handleDrawerClose = () => {
    setShowDrawer(false);
    setProfileOpen(false);
    setReloadData(true);
  };

  const handleTatDrawerClose = () => {
    setTatDrawerOpen(false);
  };

  const handleView = (row) => {
    setSelectedCandidate(row);
    setShowDrawer(false);
    setProfileOpen(true);
  };

  const handleAssign = (row) => {
    setSelectedCandidate(row);
    setShowDrawer(true);
    setProfileOpen(false);
  };

  const handleEditCandidate = (row) => {
    setSelectedCandidate(row);
    setIsEditModalVisible(true);
  };

  const calculateDurationInDays = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : new Date(); // Use current date if endDate is missing
    const durationInMilliseconds = end - start;
    return Math.max(0, Math.ceil(durationInMilliseconds / (1000 * 60 * 60 * 24))); // Ensure no negative values
  };

  const userColumns = [
    {
      name: 'Name',
      selector: (row) => row.fullName,
      cell: (row) => (
        <div style={{ textTransform: 'capitalize' }}>
          {row.fullName}
        </div>
      ),
      sortable: true,
      width: '180px',
    },
    {
      name: 'Location',
      selector: (row) => row.currentLocation,
      cell: (row) => (
        <div style={{ textTransform: 'capitalize' }}>
          {row.currentLocation}
        </div>
      ),
      sortable: true,
      width: '130px',
    },
    { name: 'Resume', cell: (row) => renderResumeLink(row), sortable: true, width: '130px' },
    { name: 'Position', selector: (row) => row.position, sortable: true, width: '200px' },
    { name: 'Job ID', selector: (row) => row.jobId, sortable: true, width: '180px' },
    {
      name: 'HR TAT',
      cell: (row) => {
        const hrTatEntries = row.tatHistory?.filter((tat) => tat.tatType === 'HR TAT');
        const totalHrTatDuration = hrTatEntries
          ? hrTatEntries.reduce((total, tat) => total + calculateDurationInDays(tat.startDate, tat.endDate), 0)
          : 0;

        return hrTatEntries && hrTatEntries.length > 0 ? (
          <div>
            <span
              style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => {
                setSelectedCandidate(row); // Set the selected candidate
                setTatDrawerOpen(true); // Open the TAT drawer
              }}
            >
              {`${totalHrTatDuration} days`}
            </span>
          </div>
        ) : (
          <span>No HR TAT</span>
        );
      },
      width: '100px',
    },
    {
      name: 'OPS TAT',
      cell: (row) => {
        const opsTatEntries = row.tatHistory?.filter((tat) => tat.tatType === 'OPS TAT');
        const totalOpsTatDuration = opsTatEntries
          ? opsTatEntries.reduce((total, tat) => total + calculateDurationInDays(tat.startDate, tat.endDate), 0)
          : 0;

        return opsTatEntries && opsTatEntries.length > 0 ? (
          <div>
            <span
              style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={() => {
                setSelectedCandidate(row); // Set the selected candidate
                setTatDrawerOpen(true); // Open the TAT drawer
              }}
            >
              {`${totalOpsTatDuration} days`}
            </span>
          </div>
        ) : (
          <span>No OPS TAT</span>
        );
      },
      width: '100px',
    },
    {
      name: 'Status',
      selector: (row) => row.status,
      sortable: true,
      width: '250px',
      cell: (row) => {
        let displayStatus = row.status;

        if (!row.isFinalRound) {
          if (row.status === 'L1 Interview Cleared') {
            displayStatus = 'L2 To be Scheduled';
          } else if (row.status === 'L2 Interview Cleared') {
            displayStatus = 'L3 To be Scheduled';
          } else if (row.status === 'L3 Interview Cleared') {
            displayStatus = 'L4 To be Scheduled';
          }
        }

        const statusesWithHover = ['L1 Interview Cleared', 'L2 Interview Cleared', 'L3 Interview Cleared'];

        return !row.isFinalRound && statusesWithHover.includes(row.status) ? (
          <Tooltip title={displayStatus}>
            <div style={{
              ...getStatusStyles(displayStatus),
              padding: '5px 10px',
              textAlign: 'center',
            }}>
              {row.status}
            </div>
          </Tooltip>
        ) : (
          <div style={{
            ...getStatusStyles(row.status),
            padding: '5px 10px',
            textAlign: 'center',
          }}>
            {row.status}
          </div>
        );
      },
    },
    {
      name: 'Actions',
      width: '160px',
      styled: { textAlign: 'center' },
      cell: (row) => (
        <div style={{ paddingTop: '10px', paddingBottom: '10px' }}>
          <Tooltip title="Assign Interview" color='cyan'>
            <button className='table-btn' onClick={() => handleAssign(row)}>
              <MdOutlineAddTask />
            </button>
          </Tooltip>
          <Tooltip title="View Details" color='cyan'>
            <button className='table-btn' onClick={() => handleView(row)}>
              <TiEyeOutline />
            </button>
          </Tooltip>
          {auth.role === "Admin" || (auth.role === "HR" && auth.email === row.mgrEmail) ? (
            <Tooltip title="Edit Candidate" color="cyan">
              <button className="table-btn" name="Edit" onClick={() => handleEditCandidate(row)}>
                <TiEdit />
              </button>
            </Tooltip>
          ) : null}

        </div>
      ),
    },
  ];

  const renderResumeLink = (row) => {
    if (row.resume) {
      let downloadLink = `${URL}${row.resume}`;
      if (row.resume.includes("google.com")) {
        downloadLink = row.resume;
      }
      return (
        <a href={downloadLink} target="_blank" rel="noopener noreferrer" className='resume-link'>
          {row.firstName} CV
        </a>
      );
    } else {
      return "Resume not available";
    }
  };

  useEffect(() => {
    if (reloadData) {
      setReloadData(false);
    }
  }, [reloadData]);

  const getStatusStyles = (status) => {
    switch (status) {
      case 'HR Interview Cleared':
        return { color: '#00B4D2' };
      case 'L1 Interview Cleared':
        return { color: '#00B4D2' };
      case 'L2 Interview Cleared':
        return { color: '#00B4D2' };
      case 'CV Rejected':
        return { backgroundColor: 'red', color: 'white' };
      case 'CV Shortlisted' || 'CV Sourced':
        return { color: '#00B4D2' };
      case 'L1 Assigned':
        return { color: '#00B4D2' };
      case 'L2 Assigned':
        return { color: '#00B4D2' };
      case 'HR Assigned':
        return { color: '#00B4D2' };
      case 'Joined':
        return { color: '#00B4D2' };
      case 'Screening Done':
        return { color: '#00B4D2' };
      default:
        return { color: '#00B4D2' };
    }
  };

  return (
    <>
      <div>
        {/* <Fetchtable
          url={`${URL}/api/candidatesreport`}
          columns={userColumns}
          setSelectedCandidate={setSelectedCandidate}
          reloadData={reloadData}
          filterOption={filterOption}
          fileName="ATS_CandidatesData"
        /> */}

        <Fetchtable
          columns={userColumns}
          data={candidates}        // ⭐ this is the key line
          reloadData={reloadData}
          fileName="ATS_CandidatesData"
        />

        {/* <AssignInterview
          open={showDrawer}
          onClose={handleDrawerClose}
          auth={auth}
          candidateId={selectedCandidate ? selectedCandidate._id : ''}
        /> */}
        {selectedCandidate && (
          <AssignInterview
            open={showDrawer}
            onClose={handleDrawerClose}
            auth={auth}
            candidateId={selectedCandidate._id}
          />
        )}

        {profileOpen &&
          <CandidateProfileDrawer
            open={profileOpen}
            onClose={handleDrawerClose}
            candidateId={selectedCandidate ? selectedCandidate._id : ''}
            candidateManager={selectedCandidate ? selectedCandidate.mgrEmail : ''}
          />}

        <Drawer

          title={
            selectedCandidate?.tatHistory?.length > 0
              ? `${selectedCandidate.tatHistory[0]?.jobId || "Job ID Not Available"} - ${(() => {
                const tatHistory = selectedCandidate.tatHistory;
                if (tatHistory.length === 0) return "0 days";

                const lastTat = tatHistory[tatHistory.length - 1];
                const endDate = lastTat.endDate || new Date(); // Use endDate if available, otherwise use current date
                const totalTatDays = calculateDurationInDays(tatHistory[0].startDate, endDate);
                return `${totalTatDays} days`;
              })()}`
              : "TAT History"
          }
          placement="left"
          closable={true}
          onClose={handleTatDrawerClose}
          open={tatDrawerOpen}
          width={400}
        >
          {selectedCandidate?.tatHistory?.length > 0 ? (
            <TATTimeline tatHistory={selectedCandidate.tatHistory} />
          ) : (
            <p>No TAT history available.</p>
          )}
        </Drawer>
        <Modal
          open={isEditModalVisible}
          onCancel={closeModal}
          footer={null}
          width={800}
          title={<h2>Edit Candidate</h2>}
        >
          <EditCandidate
            selectedCandidate={selectedCandidate}
            closeModal={closeModal}
            onUpdateSuccess={() => setReloadData(true)} />
        </Modal>
      </div>
    </>
  );
};

export default CandidateTable;